import {RouteConfig} from "vue-router"
import {PRIV} from "@/router/rights"

const routes: Array<RouteConfig> = [
  {
    path: "/news",
    name: "news-list",
    component: () => import("@/views/News/NewsList.vue"),
    meta: {
      requiresAuth: true,
      flags: [PRIV.add_news],
      layout: "home",
      title: "Новости",
    },
  },
  {
    path: "/news/create",
    name: "news-create",
    component: () => import("@/views/News/NewsForm.vue"),
    meta: {
      requiresAuth: true,
      flags: [PRIV.add_news],
      layout: "home",
      title: "Создание новости",
    },
  },
  {
    path: "/news/edit/:id",
    name: "news-edit",
    component: () => import("@/views/News/NewsForm.vue"),
    meta: {
      requiresAuth: true,
      flags: [PRIV.add_news],
      layout: "home",
      title: "Редактирование новости",
    },
  },
  {
    path: "/news/:id",
    name: "news-detail",
    component: () => import("@/views/News/NewsDetail.vue"),
    meta: {
      requiresAuth: true,
      flags: [PRIV.view_news],
      layout: "home",
      title: "Новость",
    },
  },
]

export default routes

